import { gsap, ScrollTrigger, SplitText } from 'gsap/all'
gsap.registerPlugin(SplitText, ScrollTrigger)

export function splitText(
  text: HTMLElement,
  scrolltriggerAttributes?: { trigger?: HTMLElement; start?: string; end?: string; markers?: boolean; delay?: number }
) {
  const { trigger, start, end, markers } = scrolltriggerAttributes || {}
  let mm = gsap.matchMedia()
  const copyText = text.innerHTML
  let newText: SplitText
  let innerText: SplitText
  const parentSection = text.closest('section')
  let titleAnim: GSAPTimeline

  const handleResize = () => {
    titleAnim?.kill()
    newText.revert()
    innerText.revert()
    // clear styles
    text.innerHTML = copyText
  }

  function init(): void {
    // Add the handleResize function to the window resize event
    window.addEventListener('resize', handleResize)

    // just on dekstop
    mm.add('(min-width: 992px)', () => {
      newText = new SplitText(text, {
        type: 'lines, words',
        linesClass: 'lineChild'
      })
      innerText = new SplitText(text, {
        type: 'lines',
        linesClass: 'lineParent'
      })

      gsap.set(newText.lines, { yPercent: 100 })

      titleAnim = gsap.timeline({
        scrollTrigger: {
          trigger: trigger || parentSection,
          start: start || 'top center+=15%',
          end: end || 'center center+=15%',
          scrub: 1,
          // once: true,
          invalidateOnRefresh: true,
          markers: markers || false
        },
        defaults: {
          stagger: 0.15,
          ease: 'expo.out'
        }
      })

      titleAnim.fromTo(
        newText.lines,
        {
          yPercent: 100
        },
        {
          // ease: 'power1.inOut',
          ease: 'expo.out',
          duration: 1.2,
          delay: scrolltriggerAttributes?.delay || 0,
          yPercent: 0,
          stagger: {
            each: 0.03,
            from: 0
          }
        }
      )
    })

    // mobile
    // mm.add('(max-width: 991px)', () => {
    // })
  }

  function destroy(): void {
    if (newText) newText.revert()
    if (innerText) innerText.revert()
    titleAnim.kill()
    mm.revert()
  }

  // Return the init and destroy functions
  return {
    init,
    destroy
  }
}
